import { ref, shallowRef } from "vue";
import { Upload, File, X } from "lucide-vue-next";

export const useUploadButton = () => {
  const currentIcon = shallowRef(Upload);
  const loading = ref(false);
  const buttonInfo = ref("Click to upload...");

  const determineButtonInfo = (modelValue) => (modelValue ? modelValue : buttonInfo.value);
  const determineIcon = (modelValue) => (modelValue ? File : currentIcon.value);

  const startUpload = () => {
    loading.value = true;
    buttonInfo.value = "Uploading file...";
  };

  const finishUpload = (error = null) => {
    loading.value = false;
    currentIcon.value = File;
    buttonInfo.value = "Click to upload...";

    if (error) {
      buttonInfo.value = "Upload failed.";
      currentIcon.value = X;
    }
  };

  return {
    currentIcon,
    loading,
    buttonInfo,
    determineButtonInfo,
    determineIcon,
    startUpload,
    finishUpload,
  };
};
